import { ReactElement } from 'react';

import { EncounterMode } from '@dreryk/egabinet-waitlist-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { FilterPanel, Multiselect } from '@dreryk/react-components';

import {
   WaitlistFilterPanelFormBean,
   WaitlistFilterPanelSearchParam,
   WaitlistFilterPanelStorageKey,
} from '../../WaitlistFilterPanel.types';
import { translationKeys } from '../../../translations';

import { StyledEncounterModeMultiselect } from './EncounterModesMultiselect.styled';
import {
   createEncounterModesTriggerLabelExtractor,
   ENCOUNTER_MODES,
   encounterModesCodec,
   encounterModesDeselectorsPropsMapper,
} from './EncounterModesController.utils';

type EncounterModesControllerProps = {
   registerController: BindingCreator<WaitlistFilterPanelFormBean, 'encounterModes'>;
};

export const EncounterModesController = (props: EncounterModesControllerProps): ReactElement => {
   const translate = useTranslate();
   return (
      <FilterPanel.Controller<WaitlistFilterPanelFormBean, 'encounterModes'>
         name={'encounterModes'}
         searchParam={WaitlistFilterPanelSearchParam.ENCOUNTER_MODE}
         storageKey={WaitlistFilterPanelStorageKey.ENCOUNTER_MODE}
         codec={encounterModesCodec}
         chipsLabel={translationKeys.encounterMode}
         getDeselectorsProps={encounterModesDeselectorsPropsMapper}
      >
         {({ applyFilter }) => (
            <StyledEncounterModeMultiselect<EncounterMode>
               testId={'encounterModes'}
               triggerLabelExtractor={createEncounterModesTriggerLabelExtractor(translate)}
               controller={props.registerController('encounterModes')}
               onHide={applyFilter}
               label={translationKeys.encounterMode}
               placeholder={translationKeys.chooseEncounterModes}
               compact
            >
               <>
                  <Multiselect.SelectAll testId={'selectAll'} items={ENCOUNTER_MODES} />
                  <Multiselect.List<EncounterMode> items={ENCOUNTER_MODES}>
                     {(item) => (
                        <Multiselect.Item item={item} label={translationKeys.encounterModeMap[item]} testId={item} />
                     )}
                  </Multiselect.List>
               </>
            </StyledEncounterModeMultiselect>
         )}
      </FilterPanel.Controller>
   );
};
